var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57295 13.2315C6.79695 13.2315 7.02095 13.1475 7.19384 12.9789L11.6485 8.63199C11.8198 8.46488 11.9165 8.23533 11.9165 7.99577C11.9165 7.75621 11.8198 7.52688 11.6485 7.35955L7.2025 3.02133C6.85095 2.67866 6.2885 2.68533 5.94539 3.03666C5.60273 3.38799 5.60939 3.95088 5.96073 4.29355L9.75495 7.99577L5.95206 11.7064C5.60073 12.0491 5.59406 12.612 5.93673 12.9633C6.11073 13.1418 6.34184 13.2315 6.57295 13.2315Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.f2f6c5f736eb029caa40378f895a9790.svg";
export { ForwardRef as ReactComponent };